export default __webpack_public_path__ + "static/media/contacto_6.ffe1cff9.jpeg";